import dayjs from 'dayjs';
import { CareCreditIntegrationCustom } from '@frontend/api-care-credit-integration';
import { EnrollmentFormFields } from '../widgets/care-credit-enrollment-multi-step/enrollment-multi-step.types';

/**
 *
 * Get and format data to CareCredit Standards
 */
export const getParsedEnrollmentFormFields = (fields: EnrollmentFormFields) => {
  const data: EnrollmentFormFields & { annualIncomeNumber: number } = {
    ...fields,
    dateOfBirth: fields.dateOfBirth ? dayjs(fields.dateOfBirth).format('YYYYMMDD') : '',
    phoneNumberType: CareCreditIntegrationCustom.convert.personPhoneToContactType(fields.phoneNumberType),
    ssn: fields.ssn ? fields.ssn.replace(/-/g, '') : '', // remove dashes if ssn exists
    idExpirationDate: fields.idExpirationDate ? dayjs(fields.idExpirationDate).format('YYYYMMDD') : '',
    idNumber: fields.idNumber ? fields.idNumber.replace(/[-\s.]/g, '') : '', // remove formatting, spaces, slashes, etc
    annualIncomeNumber: formatAnnualIncomeNumber(fields.monthlyNetIncome),
  };

  return data;
};

/**
 * Return monthly income converted to an annual amount AND to cents, as a whole number
 */
export const formatAnnualIncomeNumber = (monthlyNetIncome: string | number | undefined): number => {
  return Number(String(monthlyNetIncome ? Number(monthlyNetIncome) * 12 * 100 : 0));
};
